import { ApiTag } from '../tags'

export default class ColorFamily extends ApiTag {
  static readonly REGEX_CATEGORY_PATHNAME = /(company|mycolor)\.product\.color_family\.([^.]+)/

  static match(tag: ApiTag): boolean {
    return ColorFamily.REGEX_CATEGORY_PATHNAME.test(tag.pathname)
  }
}
